import * as React from "react";
import Paper from "@mui/material/Paper";
import { useEffect, useState } from "react";
import {
  Box,
  Button,
  Divider,
  Stack,
  Typography,
} from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import PrintIcon from "@mui/icons-material/Print";
import { useNavigate, useLocation } from "react-router-dom";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import axios from "axios";
import HOST_URL from "../../../utils/Url";
import Switch from "@mui/material/Switch";
import Chip from "@mui/material/Chip";
import CircularProgress from "@mui/material/CircularProgress";
import { useTranslation } from "react-i18next";
import {
  DataGrid,
  GridColDef,
  GridToolbar,
} from "@mui/x-data-grid";
import { toast } from "react-toastify";
import ToastApp from "../../../ToastApp";
import api from "../../../utils/Url";

interface MenuPermission {
  isAdd: boolean;
  isEdit: boolean;
  isPrint: boolean;
  isDel: boolean;
}

export default function WardMaster() {
  const [rows, setRows] = useState<any>([]);
  const [columns, setColumns] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [permissionData, setPermissionData] = useState<MenuPermission>({
    isAdd: false,
    isEdit: false,
    isPrint: false,
    isDel: false,
  });
 
  const { t } = useTranslation();
  const location = useLocation();

  useEffect(() => {
    const dataString = localStorage.getItem("userdata");
      if (dataString) {
        const data = JSON.parse(dataString);
        if (data && data.length > 0) {
          const userPermissionData = data[0]?.userPermission;
          if (userPermissionData && userPermissionData.length > 0) {
            const menudata = userPermissionData[0]?.parentMenu;
            for (let index = 0; index < menudata.length; index++) {
              const childMenudata = menudata[index]?.childMenu;
              const pathrow = childMenudata.find(
                (x: any) => x.path === location.pathname
              );
              if (pathrow) {
                setPermissionData(pathrow);
                getList();
              }
            }
          }
        }
      }
  }, [isLoading]);

  let ID: any = localStorage.getItem("useR_ID")
  if (ID !== null) {
    ID = ID.replace(/\D/g, '');
    // console.log("useR_ID", parseInt(ID));
  } else {
    toast.error("User ID not Found");
  }



  const handleSwitchChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    value: any
  ) => {
    const collectData = {
      wardID: value.wardID,
      wardName: value.wardName,
      zoneID: value.zoneID,
      wardCode: value.wardCode,
      isActive: event.target.checked,
      user_ID:value.user_ID,
      sortOrder: value.sortOrder,
      createdDt:value.createdDt,
      modifyDt: value.modifyDt,
      zoneName:value.zoneName,
    };
    api
      .post( `Ward/AddUpdateWardmaster`, collectData)
      .then((response) => {
        if (response.data.isSuccess) {
          toast.success(response.data.mesg);
          getList();
        } else {
          toast.error(response.data.mesg);
        }
      });
  };

  // Delete Action Option

  let delete_id = "";

  const accept = () => {
    const collectData = {
      wardID: delete_id,
      user_ID: parseInt(ID),
    };
    console.log("collectData " + JSON.stringify(collectData));
    api
      .delete(`Ward/DeleteWardmaster`, {data:collectData})
      .then((response) => {
        if (response.data.isSuccess) {
          toast.success(response.data.mesg);
        } else {
          toast.error(response.data.mesg);
        }
        getList();
      });
  };
  const reject = () => {
    // toast.warn({summary: 'Rejected', detail: 'You have rejected', life: 3000 });
    toast.warn("Rejected: You have rejected", { autoClose: 3000 });
  };

  const handledeleteClick = (del_id: any) => {
    // console.log(del_id + " del_id ");
    delete_id = del_id;
    confirmDialog({
      message: "Do you want to delete this record ?",
      header: "Delete Confirmation",
      icon: "pi pi-info-circle",
      acceptClassName: "p=-button-danger",
      accept,
      reject,
    });
  };

  const getList = () => {
    const collectData = {
      "wardID": -1,
      "zoneID": -1,
      "user_ID": parseInt(ID),
      // "isActive": true,
    };
    try {
      api
        .post(  `Ward/GetWardmaster`, collectData)
        .then((res) => {
          console.log("result" + JSON.stringify(res.data.data));
          const data = res.data.data;
          const arr = data.map((item: any, index:any) => ({
            ...item,
            serialNo:index+1,
            id: item.wardID,
          }));
          // console.log(arr);
          setRows(arr);
          setIsLoading(false);


          if (data.length > 0) {
            const columns: GridColDef[] = [
              {
                field: "actions",
                headerName: t("text.Action"),
                headerClassName: "MuiDataGrid-colCell",
                width: 150,
                renderCell: (params) => {
                  return [
                    <Stack
                      spacing={1}
                      direction="row"
                      sx={{ alignItems: "center", marginTop: "5px" }}
                    >
                      {permissionData?.isEdit ? (
                        <EditIcon
                          style={{
                            fontSize: "20px",
                            color: "blue",
                            cursor: "pointer",
                          }}
                          className="cursor-pointer"
                          onClick={() => routeChangeEdit(params.row)}
                        />
                      ) : (
                        ""
                      )}

                      {permissionData?.isDel ? (
                        <DeleteIcon
                          style={{
                            fontSize: "20px",
                            color: "red",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handledeleteClick(params.row.id);
                          }}
                        />
                      ) : (
                        ""
                      )}

                      <Switch
                        checked={Boolean(params.row.isActive)}
                        style={{
                          color: params.row.isActive ? "green" : "#FE0000",
                        }}
                        onChange={(value: any) =>
                          handleSwitchChange(value, params.row)
                        }
                        inputProps={{
                          "aria-label": "Toggle Switch",
                        }}
                      />
                    </Stack>,
                  ];
                },
              },

              {
                field: "serialNo",
                headerName: t("text.SrNo"),
                flex: 1,
                headerClassName: "MuiDataGrid-colCell",
              },
              {
                field: "wardName",
                headerName: t("text.wardName"),
                flex: 1,
                headerClassName: "MuiDataGrid-colCell",
              },
              {
                field: "wardCode",
                headerName: t("text.wardCode"),
                flex: 1,
                headerClassName: "MuiDataGrid-colCell",
              },
              {
                field: "zoneName",
                headerName: t("text.zoneName"),
                flex: 1,
                headerClassName: "MuiDataGrid-colCell",
              },
              {
                field: "isActive",
                headerName: t("text.Status"),
                flex: 1,
                headerClassName: "MuiDataGrid-colCell",

                renderCell: (params) => [
                  <Stack direction="row" spacing={1}>
                    {params.row.isActive ? (
                      <Chip
                        label={t("text.Active")}
                        color="success"
                        style={{ fontSize: "14px" }}
                      />
                    ) : (
                      <Chip
                        // label="InActive"
                        label={t("text.InActive")}
                        color="error"
                        style={{ fontSize: "14px" }}
                      />
                    )}
                  </Stack>,
                ],
              },
            ];
            setColumns(columns as any);
          }
        });
    } catch (error) {
      console.error("Error fetching data:", error);
      // setIsLoading(false);
    }
  };

  const routeChangeEdit = (row: any) => {
    // console.log(row);
    let path = `/master/WardMasterEdit`;
    navigate(path, {
      state: row,
    });
  };

  /// NEXT PAGE

  let navigate = useNavigate();
  const routeChangeAdd = () => {
    let path = `/master/WardMasterAdd`;
    navigate(path);
  };

  return (
    <>
      <Grid item lg={6} sm={6} xs={12} sx={{marginTop:"3vh"}}>
        <Card
          style={{
            width: "100%",
            height: "50%",
            backgroundColor: "#E9FDEE",
            border: ".5px solid green ",
          }}
        >
          <Paper
            sx={{
              width: "100%",
              overflow: "hidden",
              "& .MuiDataGrid-colCell": {
                backgroundColor: "#2B4593",
                color: "#fff",
                fontSize: 17,
                fontWeight: 800,
              },
            }}
            style={{ padding: "10px" }}
          >
            <ConfirmDialog />
            <Typography
              gutterBottom
              variant="h5"
              component="div"
              sx={{ padding: "20px" }}
              align="left"
            >
              {t("text.wardMaster")}
            </Typography>
            <Divider />

            {/* Search and ADD buttone Start */}
            <Box height={10} />
            <Stack direction="row" spacing={2} classes="my-2 mb-2">
              {permissionData?.isAdd == true ? (
                <Button
                  onClick={routeChangeAdd}
                  variant="contained"
                  endIcon={<AddCircleIcon />} 
                  size="large"
                >
                  {t("text.add")}
                </Button>
              ) : (
                ""
              )}
              {/* {permissionData?.isPrint == true ? (
                <Button variant="contained" 
                endIcon={<PrintIcon />}
                size="large">
                  {t("text.print")}
                </Button>
              ) : (
                ""
              )} */}
              <Typography
                variant="h6"
                component="div"
                sx={{ flexGrow: 1 }}
              ></Typography>
            </Stack>

            {isLoading ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CircularProgress />
              </div>
            ) : (
              <Box>
            <br></br>
            <div style={{ width: "100%", backgroundColor: "#FFFFFF" }}>
              <DataGrid
                rows={rows}
                columns={columns}
                autoHeight
                slots={{
                  toolbar: GridToolbar,
                }}
                rowSpacingType="border"
                pagination={true}
                pageSizeOptions={[5, 10, 25, 50, 100].map((size) => ({
                  value: size,
                  label: `${size}`,
                }))}
                initialState={{
                  pagination: { paginationModel: { pageSize: 5 } },
                }}
                slotProps={{
                  toolbar: {
                    showQuickFilter: true,
                  },
                }}
              />
            </div>
          </Box>)}
          </Paper>
        </Card>
      </Grid>
      <ToastApp />
    </>
  );
}

// import * as React from "react";
// import Paper from "@mui/material/Paper";
// import Table from "@mui/material/Table";
// import TableBody from "@mui/material/TableBody";
// import TableCell from "@mui/material/TableCell";
// import TableContainer from "@mui/material/TableContainer";
// import TableHead from "@mui/material/TableHead";
// import TablePagination from "@mui/material/TablePagination";
// import TableRow from "@mui/material/TableRow";
// import { useEffect, useState } from "react";
// import {
//   Box,
//   Button,
//   Divider,
//   Stack,
//   TextField,
//   Typography,
// } from "@mui/material";
// import AddCircleIcon from "@mui/icons-material/AddCircle";
// import SearchIcon from "@mui/icons-material/Search";
// import Swal from "sweetalert2";
// import EditIcon from "@mui/icons-material/Edit";
// import DeleteIcon from "@mui/icons-material/Delete";
// import Card from "@mui/material/Card";
// import Grid from "@mui/material/Grid";
// import PrintIcon from "@mui/icons-material/Print";
// import { useNavigate, useLocation } from "react-router-dom";
// import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
// import axios from "axios";
// import HOST_URL from '../../../utils/Url';
// import Switch from "@mui/material/Switch";
// import Chip from '@mui/material/Chip';
// import CircularProgress from "@mui/material/CircularProgress";
// import { useTranslation } from "react-i18next";
// import {
//   DataGrid,
//   GridColDef,
//   GridToolbar,
//   GridActionsCellItem,
// } from "@mui/x-data-grid";

// interface MenuPermission {
//   isAdd: boolean;
//   isEdit: boolean;
//   isPrint: boolean;
// }
// function createData(
//   srno: number,
//   id: string,
//   WardName: string,
//   WardCode: string,
//   Status: string,
//   zoneID: number,

// ): any {
//   return { srno, id, WardName, WardCode, Status, zoneID };
// }

// export default function WardMaster() {
//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(5);
//   const [rows, setRows] = useState<any>([]);
//   const [records, setRecords] = useState(rows);
//   // const [menupermisiondata, setMenupermisiondata] = useState<any>();
//   const [isLoading, setIsLoading] = useState(true);
// const [columns, setColumns] = useState<any>([]);

// const [menupermisiondata, setMenupermisiondata] = useState<MenuPermission>({
//   isAdd: false,
//   isEdit: false,
//   isPrint: false,
// });
//   //Search Filter
//   const location = useLocation();

//   let delete_id = "";
//   function handleFilter(event: any) {
//     const newRows = rows.filter((rowss: { WardName: string }) => {
//       return rowss.WardName
//         .toLowerCase()
//         .includes(event.target.value.toLowerCase());
//     });
//     setRecords(newRows);
//     setPage(0);
//   }

//   const handleChangePage = (event: unknown, newPage: number) => {
//     setPage(newPage);
//   };

//   const handleChangeRowsPerPage = (
//     event: React.ChangeEvent<HTMLInputElement>
//   ) => {
//     setRowsPerPage(+event.target.value);
//     setPage(0);
//   };

//   const {t } = useTranslation();

//   useEffect(() => {
//     const fetchData = async () => {
//       await getPermissionData();
//     };
//     fetchData();
//   }, []);

//   useEffect(() => {
//     getList();
//   }, [menupermisiondata]);

//   const getPermissionData = async () => {
//       let dataString = localStorage.getItem("userdata");
//       if (dataString) {
//         let data = JSON.parse(dataString);
//         if (data && data.length > 0) {
//           let userPermissionData = data[0]?.userPermission;
//           if (userPermissionData && userPermissionData.length > 0) {
//             let menudata = userPermissionData[0]?.parentMenu;
//             for (let index = 0; index < menudata.length; index++) {
//               let childMenudata = menudata[index]?.childMenu;
//               let pathrow = childMenudata.find(
//                 (x: any) => x.path === location.pathname
//               );
//               if (pathrow) {
//                 setMenupermisiondata(pathrow);
//              break;
//               }

//             }
//           }
//         }
//       }
//     }

//   const handleSwitchChange = (event: React.ChangeEvent<HTMLInputElement>,value:any) => {
//     const collectData = {
//       wardID:value.id,
//       zoneID: value.zoneID,
//       wardName: value.WardName,
//       wardCode: value.WardCode,
//       isActive: event.target.checked,
//       user_ID: -1,
//       sortOrder: 0,
//     }
//     axios.post(HOST_URL.HOST_URL + `Ward/AddUpdateWardmaster`, collectData)
//       .then(res => {
//         if (res.data.isSuccess) {
//           getList();
//         }
//       })
//   };
//   // Delete Action Option

//   const deleteUser = () => {
//     Swal.fire({
//       title: "Are you sure ?",
//       text: "You won't be able to revert this !",
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonColor: "#3085d6",
//       cancelButtonColor: "#d33",
//       confirmButtonText: "Yes, Delete it!",
//     }).then((result: any) => {
//       if (result.isConfirmed) {
//         // console.log("Use clicked ok");
//         // deleteApi(id);
//       } else {
//         // console.log("Use Clicked Cancel");
//       }
//     });
//   };
// const getList = () => {
//     const collectData = {
//       wardID: -1,
//       user_ID: -1,
//     }
//     try {
//     axios.post(HOST_URL.HOST_URL+`Ward/GetWardmaster`, collectData).then((res) => {
//       console.log("result" + JSON.stringify(res.data.data));
//       const data = res.data.data;
//       const arr = data.map((item: any) => ({
//                 ...item,
//                 id: item.wardID,
//               }));
//       // console.log(arr);
//       setRows(arr);
//       setIsLoading(false);

//       if (data.length > 0) {
//         const columns: GridColDef[] = [
//           {field: "actions",headerName:t("text.Action"),headerClassName:"MuiDataGrid-colCell", width: 150,
//           renderCell: (params) => {
//             return [
//              <Stack spacing={2} direction="row">
//                {menupermisiondata?.isEdit ? (
// <EditIcon
// style={{
//   fontSize: "20px",
//   color: "blue",
//   cursor: "pointer",
// }}
// className="cursor-pointer"
// onClick={() => routeChangeEdit(params.row)}
// />
//    ) : (
//     ""
//   )}
//                   <Switch
//                     checked={Boolean(params.row.isActive)}
//                     style={{
//                       color: params.row.isActive ? "green" : "#FE0000",
//                     }}
//                     onChange={(value: any) =>
//                       handleSwitchChange(value, params.row)
//                     }
//                     inputProps={{
//                       "aria-label": "Toggle Switch",
//                     }}
//                   />
//                 </Stack>,
//               ];
//             },
//           },

//           { field: "wardID", headerName:t("text.SrNo"), flex: 1,  headerClassName:"MuiDataGrid-colCell", },
//           { field: "wardName", headerName:t("text.wardName"), flex: 1, headerClassName:"MuiDataGrid-colCell",  },
//           { field: "wardCode", headerName: t("text.wardCode"), flex: 1,  headerClassName:"MuiDataGrid-colCell", },
//           { field: "zoneName", headerName:t("text.zoneName"), flex: 1,  headerClassName:"MuiDataGrid-colCell", },
//           {field: "isActive",headerName:t("text.Status"),flex: 1,
//            headerClassName:"MuiDataGrid-colCell",

//             renderCell: (params) => [
//               <Stack direction="row" spacing={1}>
//                 {params.row.isActive ? (
//                   <Chip
//                     label={t("text.Active")}
//                     color="success"
//                     style={{ fontSize: "14px" }}
//                   />
//                 ) : (
//                   <Chip
//                     // label="InActive"
//                     label={t("text.InActive")}
//                     color="error"
//                     style={{ fontSize: "14px" }}
//                   />
//                 )}
//               </Stack>,
//             ],
//           },
//         ];
//         setColumns(columns as any);
//       }
//     })
//     setIsLoading(false);
//     } catch (error) {
//       console.error("Error fetching data:", error);
//       setIsLoading(false);
//     }
//   };

//   const findArrayElementByTitle = (array: any[], title: any) => {
//     return array.find((element) => {
//       return element.id === title;
//     });
//   };

//   const routeChangeEdit = (row: any) => {
//     // console.log(row);
//     let path = `/master/WardMasterEdit`;
//     navigate(path, {
//       state: row,
//     });
//   };

//   /// NEXT PAGE

//   let navigate = useNavigate();
//   const routeChangeAdd = () => {
//     let path = `/master/WardMasterAdd`;
//     navigate(path);
//   };

//   return (
//     <>
//       <Grid item lg={6} sm={6} xs={12}>
//         <Card
//           style={{
//             width: "100%",
//             height: "50%",
//             backgroundColor: "#E9FDEE",
//             border: ".5px solid green ",
//           }}
//         >
//           <Paper
//             sx={{ width: "100%", overflow: "hidden", '& .MuiDataGrid-colCell': {
//                         backgroundColor: '#f0ad4e',
//                         color: '#000',
//                         fontSize:18,
//                         fontWeight:800
//                       }, }}
//             style={{ padding: "10px" }}
//           >
//             <ConfirmDialog/>
//             <Typography
//               gutterBottom
//               variant="h5"
//               component="div"
//               sx={{ padding: "20px" }}
//               align="left"
//             >
//               {t("text.wardMaster")}
//             </Typography>
//             <Divider />

//             {/* Search and ADD buttone Start */}
//             <Box height={10} />
//             <Stack direction="row" spacing={2} classes="my-2 mb-2">
//             {menupermisiondata?.isAdd == true ?(
//               <Button
//                 onClick={routeChangeAdd}
//                 variant="contained"
//                 endIcon={<AddCircleIcon />}
//               >
//                 {t("text.add")}
//               </Button>):""}
//               {menupermisiondata?.isPrint == true ? (
//               <Button variant="contained" endIcon={<PrintIcon />}>
//                   {t("text.print")}
//               </Button>):""}
//               <Typography
//                 variant="h6"
//                 component="div"
//                 sx={{ flexGrow: 1 }}
//               ></Typography>

//             </Stack>

//             {isLoading ? (
//               <div style={{
//                 display: "flex",
//                 justifyContent: "center",
//                 alignItems: "center",
//               }}>
//               <CircularProgress/>
//               </div>
//             ) : (
//               <Box>
//                 <br></br>
//                 <div style={{ width: "100%", backgroundColor: "#FFFFFF" }}>
//           <DataGrid
//             rows={rows}
//             columns={columns}
//             autoHeight
//             slots={{
//               toolbar: GridToolbar,
//             }}
//             rowSpacingType="border"
//             pagination={true}
//             pageSizeOptions={[5, 10, 25, 50, 100].map((size) => ({
//               value: size,
//               label: `${size}`,
//             }))}
//             initialState={{
//               pagination: {paginationModel: {pageSize: 5 }},

//             }}
//             slotProps={{
//               toolbar: {
//                 showQuickFilter: true,
//               },
//             }}
//           />
//         </div>
//             </Box>
//             )}
//           </Paper>
//         </Card>
//       </Grid>
//     </>
//   );
// }

// // t("text.Action")

// // t("text.Status")

// ///
// // t("text.RegNo")
// // t("text.SecurityDepositAmount")
// // t("text.Date")

// // t("text.PaymentMode")
// // t("text.Refundable")

// // <img
// // src={reports}
// // width={25}
// // height={25}
// // onClick={() => {
// //   getModalList(row.id);
// //   handleOtherDocOpen();
// // }}
// // />
